import { EchoFilterCheckbox } from './types';

export const hasSelectedDescendant = (checkbox: EchoFilterCheckbox): boolean => {
    return checkbox.children.some((child) => child.isSelected || hasSelectedDescendant(child));
};

export const clearCheckboxSelection = (checkboxes: EchoFilterCheckbox[]): void => {
    checkboxes.forEach((checkbox) => {
        checkbox.isSelected = false;
        clearCheckboxSelection(checkbox.children);
    });
};
